export default "__VITE_ASSET__BtqPVGOL__"